module.exports = __webpack_public_path__ + "img/continental-logo.d8e6a706.jpg";